import script from "./FooterComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterComponent.vue?vue&type=script&setup=true&lang=js"

import "./FooterComponent.vue?vue&type=style&index=0&id=2dcc79f0&lang=css"

const __exports__ = script;

export default __exports__